import { ParseAdapter } from '../abstract/ParseAdapter';
import { Tchekb, SeverityVehicleParts } from './tchekb.model';
import { TchekImage, TchekImageUrl } from './image';
import { Folder } from './folder.model';
import { timingSafeEqual } from 'crypto';
import { DamageVehicle } from './damageVehicle.model';

export enum classificationStatusRoi {
    classified,
    skipUninteresting,
    skipIdontknow,
    falsePositive,
}
export class Damage extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get deletedWithYolo(): boolean { return (this.parseObject.get('deletedWithYolo')); }
    set deletedWithYolo(value: boolean) { this.parseObject.set('deletedWithYolo', value); }

    get checkedReport(): boolean { return (this.parseObject.get('checkedReport')); }
    set checkedReport(value: boolean) { this.parseObject.set('checkedReport', value); }

    get radiusWorld(): number { return this.parseObject.get('radiusWorld'); }
    set radiusWorld(value: number) { this.parseObject.set('radiusWorld', value); }

    get progress(): number { return this.parseObject.get('progress'); }
    set progress(value: number) { this.parseObject.set('progress', value); }

    get uid(): number { return this.parseObject.get('uid'); }
    set uid(value: number) { this.parseObject.set('uid', value); }

    get isDeleted(): boolean { return this.parseObject.get('isDeleted'); }
    set isDeleted(value: boolean) { this.parseObject.set('isDeleted', value); }

    get ignoreIt(): boolean { return this.parseObject.get('ignoreIt'); }
    set ignoreIt(value: boolean) { this.parseObject.set('ignoreIt', value); }

    get inspected(): boolean { return this.parseObject.get('inspected'); }
    set inspected(value: boolean) { this.parseObject.set('inspected', value); }

    get roiPtr(): Roi { return new Roi(this.parseObject.get('roiPtr')); }
    set roiPtr(value: Roi) { this.parseObject.set('roiPtr', value.getParseInstance()); }

    get tchekPtr(): Tchekb { return new Tchekb(this.parseObject.get('tchekPtr')); }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value.getParseInstance()); }

    get position(): { x: number, y: number, z: number } {
        return this.parseObject.get('position');
    }
    set position(value: { x: number, y: number, z: number }) {
        this.parseObject.set('position', value);
    }

    get count(): number { return this.parseObject.get('count'); }
    set count(value: number) { this.parseObject.set('count', value); }

    get score(): number { return this.parseObject.get('score'); }
    set score(value: number) { this.parseObject.set('score', value); }

    get location(): string { return this.parseObject.get('location'); }
    set location(value: string) { this.parseObject.set('location', value); }

    get type(): string { return this.parseObject.get('type'); }
    set type(value: string) { this.parseObject.set('type', value); }

    get confidence(): number { return this.parseObject.get('confidence'); }
    set confidence(value: number) { this.parseObject.set('confidence', value); }

    get sizeRange(): string { return this.parseObject.get('sizeRange'); }
    set sizeRange(value: string) { this.parseObject.set('sizeRange', value); }

    get severity(): string { return this.parseObject.get('severityDamage'); }
    set severity(value: string) { this.parseObject.set('severityDamage', value); }

    get toSync(): boolean { return this.parseObject.get('toSync'); }
    set toSync(value: boolean) { this.parseObject.set('toSync', value); }

    get cost(): number { return this.parseObject.get('cost'); }
    set cost(value: number) { this.parseObject.set('cost', value); }

    get costType(): string { return this.parseObject.get('costType'); }
    set costType(value: string) { this.parseObject.set('costType', value); }

    get sev(): string { return this.parseObject.get('sev'); }
    set sev(value: string) { this.parseObject.set('sev', value); }

    get isAuto(): boolean { return this.parseObject.get('isAuto'); }
    set isAuto(value: boolean) { this.parseObject.set('isAuto', value); }

    get percentBestRoi(): string {
        if (this.parseObject.get('roiPtr').get('score'))
            return ((this.parseObject.get('roiPtr').get('score') * 100).toFixed(1));
        else
            return null;
    }

    get detectionCount(): number { return this.parseObject.get('detectionCount'); }
    get uploadPicture(): boolean { return this.parseObject.get('uploadPicture'); }

    get classification(): boolean { return this.parseObject.get('classification'); }
    set classification(value: boolean) { this.parseObject.set('classification', value); }

    get seenByInspector(): boolean { return this.parseObject.get('seenByInspector'); }
    set seenByInspector(value: boolean) { this.parseObject.set('seenByInspector', value); }

    get skipClassification(): boolean { return this.parseObject.get('skipClassification'); }
    set skipClassification(value: boolean) { this.parseObject.set('skipClassification', value); }

    get activeLearningStatus(): string[] {
        if (this.parseObject.get('activeLearningStatus'))
            return this.parseObject.get('activeLearningStatus')
        else return []
    }
    set activeLearningStatus(value: string[]) { this.parseObject.set('activeLearningStatus', value); }

    get parentPtr(): DamageVehicle {
        if ((this.parseObject.get instanceof Function) === false)
            return undefined
        else if (this.parseObject.get('parentPtr') !== undefined)
            return new DamageVehicle(this.parseObject.get('parentPtr'));
        else
            return undefined
    }
    set parentPtr(value: DamageVehicle) { this.parseObject.set('parentPtr', value.getParseInstance()); }
}

export class DamageAnalysis extends Damage {
    listRoi: RoiAnalysis[];
    bestImageUrl: TchekImageUrl;
    imagesUrl: TchekImageUrl[];
    imageOverlay: string;
    isParentDamage: boolean = false;

    constructor(damage: Damage, listRoi: RoiAnalysis[]) {
        super(damage.getParseInstance());

        // THIS IS THE OLD DEFINITION
        // this.isParentDamage = damage !== undefined
        //     && damage.parentPtr !== undefined
        //     && (damage.parentPtr.tchekPtrId === undefined
        //         || damage.tchekPtr.id !== damage.parentPtr.tchekPtrId)

        // THIS IS THE BIG DEFINITION OF WETHER A DAMMAGE IS NEW OR NOT !!
        // SHOULD BE DEPORTED TO THE BACKEND BUT WE ARE LATE IN THE SPRINT SO SCREW IT
        this.isParentDamage = (damage && damage.parentPtr && damage.tchekPtr.id !== damage.parentPtr.tchekPtrId);

        this.listRoi = []
        this.bestImageUrl = new TchekImageUrl();
        this.imagesUrl = [];
        if (listRoi)
            listRoi.forEach(roi => {
                if (roi.damagePtr.id === damage.id) {
                    if (roi.id === damage.roiPtr.id)
                        this.listRoi.unshift(roi)
                    else
                        this.listRoi.push(roi)
                }
            })
    }
}

export interface DamageControlInterface {
    damageChanges: DamageAnalysis;
    originalSeverity: string;
    originalType: string;
    originalSize: string;
    originalLocation: string;
    originalBestRoiId: string;
    endTime: number;
    startTime: number;
    deleteReason: { key: string, value: string, other: string };
    validated: boolean;
}


export interface DamagesGroupedByLocation {
    location: string;
    severityPart: SeverityVehicleParts;
    svgLocation: string;
    newDamages: boolean;
    damages: DamageAnalysis[];
}

// --- ROI SECTION ---

export class Roi extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }

    get imagePtr(): TchekImage {
        if (this.parseObject.get('imagePtr')) return new TchekImage(this.parseObject.get('imagePtr'))
        else return undefined
    }
    set imagePtr(value: TchekImage) { this.parseObject.set('imagePtr', value); }

    get centerX(): number { return this.parseObject.get('centerX'); }
    set centerX(value: number) { this.parseObject.set('centerX', value); }

    get centerY(): number { return this.parseObject.get('centerY'); }
    set centerY(value: number) { this.parseObject.set('centerY', value); }

    get width(): number { return this.parseObject.get('width'); }
    set width(value: number) { this.parseObject.set('width', value); }

    get height(): number { return this.parseObject.get('height'); }
    set height(value: number) { this.parseObject.set('height', value); }

    get isDeleted(): boolean { return this.parseObject.get('isDeleted'); }
    set isDeleted(value: boolean) { this.parseObject.set('isDeleted', value); }

    get isValidated(): boolean { return this.parseObject.get('isValidated'); }
    set isValidated(value: boolean) { this.parseObject.set('isValidated', value); }

    get userPtr(): Parse.User { return this.parseObject.get('userPtr'); }
    set userPtr(value: Parse.User) { this.parseObject.set('userPtr', value); }

    get tchekPtr(): Tchekb { return new Tchekb(this.parseObject.get('tchekPtr')); }
    set tchekPtr(value: Tchekb) { this.parseObject.set('tchekPtr', value.getParseInstance()); }

    get damagePtr(): Damage { return new Damage(this.parseObject.get('damagePtr')); }
    set damagePtr(value: Damage) { this.parseObject.set('damagePtr', value.getParseInstance()); }

    get folderPtr(): Folder {
        if (this.parseObject.get('folderPtr')) return new Folder(this.parseObject.get('folderPtr'));
        else return undefined
    }
    set folderPtr(value: Folder) { this.parseObject.set('folderPtr', value.getParseInstance()); }

    get mask(): any { return this.parseObject.get('mask'); }
    set mask(value: any) { this.parseObject.set('mask', value); }

    get webObjectId(): string { return this.parseObject.get('webObjectId'); }
    set webObjectId(value: string) { this.parseObject.set('webObjectId', value); }

    get radius(): number { return this.parseObject.get('radius'); }
    set radius(value: number) { this.parseObject.set('radius', value); }

    get score(): number { return this.parseObject.get('score'); }
    set score(value: number) { this.parseObject.set('score', value); }

    get toSync(): boolean { return this.parseObject.get('toSync'); }
    set toSync(value: boolean) { this.parseObject.set('toSync', value); }

    get isAuto(): boolean { return this.parseObject.get('isAuto'); }
    set isAuto(value: boolean) { this.parseObject.set('isAuto', value); }

    get validationScore(): number { return this.parseObject.get('validationScore'); }
    set validationScore(value: number) { this.parseObject.set('validationScore', value); }

    get x(): number { return this.parseObject.get('x'); }
    set x(value: number) { this.parseObject.set('x', value); }

    get y(): number { return this.parseObject.get('y'); }
    set y(value: number) { this.parseObject.set('y', value); }

    get picture(): number { return this.parseObject.get('picture'); }
    set picture(value: number) { this.parseObject.set('picture', value); }

    get folder(): string { return this.parseObject.get('folder'); }
    set folder(value: string) { this.parseObject.set('folder', value); }

    get comment(): string { return this.parseObject.get('comment'); }
    set comment(value: string) { this.parseObject.set('comment', value); }

    get isProjected(): boolean { return this.parseObject.get('isProjected'); }
    set isProjected(value: boolean) { this.parseObject.set('isProjected', value); }


    get isComposed(): boolean { return this.parseObject.get('isComposed'); }
    set isComposed(value: boolean) { this.parseObject.set('isComposed', value); }

    get classificationStatus(): number { return this.parseObject.get('classificationStatus'); }
    set classificationStatus(value: number) { this.parseObject.set('classificationStatus', value); }

}

export class ModelIa extends ParseAdapter {
    constructor(parseObject: Parse.Object) {
        super(parseObject);
    }
    get name(): string { return this.parseObject.get('name'); }
    set name(value: string) { this.parseObject.set('name', value); }

    get description(): string { return this.parseObject.get('description'); }
    set description(value: string) { this.parseObject.set('description', value); }
}

export class RoiAnalysis extends Roi {
    bestImageUrl: TchekImageUrl;
    imagesUrl: TchekImageUrl[];


    constructor(roi: Roi) {
        super(roi.getParseInstance());
        this.bestImageUrl = new TchekImageUrl();
        this.imagesUrl = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/model/damage.model.ts